import { useEffect } from 'react';
import { datadogLogs } from '@datadog/browser-logs';

const getSegmentKey = (env) => {
  switch (env) {
    case 'local': {
      return process.env.REACT_APP_SEGMENT_KEY_DEV;
    }
    case 'dev': {
      return process.env.REACT_APP_SEGMENT_KEY_DEV;
    }
    case 'qa': {
      return process.env.REACT_APP_SEGMENT_KEY_QA;
    }
    case 'load': {
      return process.env.REACT_APP_SEGMENT_KEY_LOAD;
    }
    case 'load01': {
      return process.env.REACT_APP_SEGMENT_KEY_LOAD01;
    }
    case 'prod': {
      return process.env.REACT_APP_SEGMENT_KEY;
    }
    default: {
      return datadogLogs.logger.error('Global Cart is missing ENV prop used for Segment Analytics');
    }
  }
};

const useAnalytics = (env) => {
  useEffect(() => {
    //script was pulled from Pandora repo
    const segmentKey = getSegmentKey(env);
    const analytics = (global.window.analytics = global.window?.analytics || []);
    if (!analytics.initialize) {
      if (analytics.invoked) {
        if (typeof global.window !== 'undefined') {
          datadogLogs.logger.warn('Segment snippet included twice.');
        }
      } else {
        analytics.invoked = true;
        analytics.methods = [
          'trackSubmit',
          'trackClick',
          'trackLink',
          'trackForm',
          'pageview',
          'identify',
          'reset',
          'group',
          'track',
          'ready',
          'alias',
          'debug',
          'page',
          'once',
          'off',
          'on',
        ];
        analytics.factory = function (t) {
          return function () {
            const e = Array.prototype.slice.call(arguments);
            e.unshift(t);
            analytics.push(e);
            return analytics;
          };
        };
        analytics.methods.forEach((method) => {
          analytics[method] = analytics.factory(method);
        });
        analytics.load = function (t, e) {
          if (typeof global.window !== 'undefined') {
            const n = global.window?.document?.createElement('script');
            n.type = 'text/javascript';
            n.async = !0;
            n.src = `https://cdn.segment.com/analytics.js/v1/${t}/analytics.min.js`;
            const a = global.window?.document?.getElementsByTagName('script')[0];
            a.parentNode.insertBefore(n, a);
            analytics._loadOptions = e;
          }
        };
        // TODO! confirm what is this following line for
        analytics.SNIPPET_VERSION = '4.1.0';
        analytics.load(segmentKey);
      }
    }
  }, [env]);
};

export default useAnalytics;
